import request from "./config";

export default class ProductInputService {
  static create(data) {
    return request({
      url: "/product-entry",
      method: "post",
      data,
    });
  }
  static update(id,data) {
    return request({
      url: `/product-entry/${id}`,
      method: "patch",
      data,
    });
  }
  static delete(id) {
    return request({
      url: `/product-entry/${id}`,
      method: "delete",
    });
  }
  static  find(params) {
    return request({
      url: `/product-entry`,
      method: "get",
      params:params
    });
  }
}
